// extracted by mini-css-extract-plugin
module.exports = {"canvas":"Body_canvas_2FEZB","canvasInner":"Body_canvasInner_1Z60i","card":"Body_card_36-jm","tool":"Body_tool_29j47","download":"Body_download_1u28P"};